import React from 'react';

import { addWithConfig } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import LoyaltyRewardsLogo from 'pages/loyalty/loyalty-rewards-logo';
import { getDesignToken, primitive, spacing } from 'styles/constants';

const MAX_WIDTH_FOR_REWARDS_LOGO = '262px';

const styles = StyleSheet.create({
  pointsExpirationContainer: {
    backgroundColor: getDesignToken('background-card'),
    borderColor: primitive.$mayoEggWhite,
    borderRadius: 10,
    borderStyle: 'solid',
    borderWidth: 1,
    marginBottom: spacing.$2,
  },
  pointsExpirationHeader: {
    alignItems: 'center',
    flexDirection: 'column',
    padding: spacing.$4,
  },
  pointsExpirationContent: {
    alignItems: 'center',
    flexDirection: 'column',
    padding: spacing.$4,
  },
  divider: {
    borderTopColor: primitive.$greyFive,
    borderTopWidth: 1,
  },
  availableBalance: {
    flexDirection: 'row',
    marginTop: spacing.$2,
  },
  expirationMessage: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginBottom: spacing.$1_5,
  },
  expirationDateTime: {
    fontFamily: 'alternative',
    paddingLeft: spacing.$1_5,
  },
  purchaseMessage: {
    width: '100%',
  },
  availablePoints: {
    fontFamily: 'alternative',
    lineHeight: 21,
  },
});

export const PointsExpirationContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.pointsExpirationContainer, style] });

export const PointsExpirationHeader = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.pointsExpirationHeader, style] });

export const PointsExpirationContent = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.pointsExpirationContent, style] });

export const Divider = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.divider, style] });

export const AvailableBalance = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.availableBalance, style] });

export const NormalText = withTypography({ fontSize: 'md' });

export const StyledLoyaltyPointsIcon = addWithConfig(LoyaltyPointsIcon).withConfig({
  width: '$6',
  height: '$6',
  marginTop: {
    base: '-2px',
    md: '1px',
  },
  marginLeft: '$1',
  _android: {
    marginTop: '-1px',
  },
});

export const ExpirationMessage = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.expirationMessage, style] });

export const ExpirationDateTime = withTypography({
  mb: '$4',
  style: styles.expirationDateTime,
});

export const PurchaseMessage = withTypography({
  mb: '$4',
  textAlign: 'center',
  style: styles.purchaseMessage,
});

export const StyledRewardsLogo = LoyaltyRewardsLogo.withConfig({
  maxWidth: MAX_WIDTH_FOR_REWARDS_LOGO,
  width: 'full',
  marginTop: '$2',
});

export const AvailablePoints = withTypography({
  mx: '$1',
  style: styles.availablePoints,
});
